import { Case } from '../../../beans/Case';
import { Nakazatelno } from '../../../beans/nakazatelno';
import { FrxBaseBean } from '../../../beans/frxbasebean';
import { Nomenclature } from '../../../beans/Nomenclature';
import { Lawyer } from '../../../beans/Lawyer';
import { StatusesTask } from '../../../beans/StatusesTask';
import { TaskFrx } from '../../../beans/TaskFrx';
import { WordTemplate } from '../../../beans/word-template';
import { BlockUiService } from '../../../services/blockui.service';
import { CaseService } from '../../../services/case.service';
import { NomenclatureService } from '../../../services/nomenclature.service';
import { TaskService } from '../../../services/task.service';
import { WordTemplateService } from '../../../services/word-template.service';
import { EditCaseComponent } from '../edit-case.component';
import { DatePipe } from '@angular/common';
import { Component, OnInit, Input, ViewContainerRef, Host } from '@angular/core';
import { forkJoin } from 'rxjs';

@Component({
	selector: 'app-edit-case-nakazatelno',
	templateUrl: './edit-case-nakazatelno.component.html',
	styleUrls: ['./edit-case-nakazatelno.component.scss']
})
export class EditCaseNakazatelnoComponent implements OnInit {

	private _caseid;
	private _nakazatelnoDelo: Nakazatelno;
	selectedNakStatusId: number = null;

	addDelo = 'Добави инстанция';
	instance: Nomenclature;
	city: Nomenclature;
	court: Nomenclature;
	'number': string;
	dataNasrocheno: string;
	timeNasrocheno = '12:00';
	message = '';
	status: Nomenclature;
	note: string;
	prokurorskaPrepiskaNomer: string;
	zmMvrNomer: string;
	lawyerNakazatelno: Lawyer;
	task: TaskFrx;
	selectedTask: StatusesTask;
	nakazatelniTasks: Array<TaskFrx>;
	cases: Array<Nakazatelno>;
	otgovornici: Array<Lawyer>;
	instances: Array<Nomenclature>;
	cities: Array<Nomenclature>;
	courts: Array<Nomenclature>;
	statuses: Array<Nomenclature>;
	statusesTask: Array<StatusesTask>;
	lawyers: Array<Lawyer>;

	public cols = [
		{ title: 'Създадено на', name: 'createdDate', dataType: 'date' },
		{ title: 'Насрочено за', name: 'dataNasrocheno', dataType: 'date' },
		{ title: 'Час', name: 'timeNasrocheno' },
		{ title: 'Номер', name: 'number' },
		{ title: 'Номер Прокурорска Преписка', name: 'prokusrorskaPrepiskaNomer' },
		{ title: 'Статус', name: 'status', dataType: 'object', complexDataType: { object: true, displayValue: 'name' } },
		{ title: 'ЗМ МВР Номер', name: 'zmMvrNomer' },
		{ title: 'Инстанция', name: 'instance', dataType: 'object', complexDataType: { object: true, displayValue: 'name' } },
		{ title: 'Град', name: 'city', dataType: 'object', complexDataType: { object: true, displayValue: 'name' } },
		{ title: 'Съд', name: 'court', dataType: 'object', complexDataType: { object: true, displayValue: 'name' } },
		{ title: 'Бележка', name: 'note' },
		{ title: 'Съдия - докладчик', name: 'sudiaDokladchik' },
	];

	public colsTask = [
		{ title: 'Deadline', name: 'deadline', dataType: 'date' },
		{ title: 'Описание', name: 'opisanie' },
		{ title: 'Статус', name: 'statusTaskBG' },
		{ title: 'Отговорник', name: 'otgovornik', dataType: 'object', complexDataType: { object: true, displayValue: 'username' } }
	];

	// Word templates
	nakTemplates: WordTemplate[] = [];
	selectedNakTemplate: WordTemplate = null;

	constructor(private caseService: CaseService,
		private nomenclatureService: NomenclatureService,
		private blockUi: BlockUiService,
		private vcRef: ViewContainerRef,
		private taskService: TaskService,
		private datePipe: DatePipe,
		private wordTemplateService: WordTemplateService,
		@Host() private parentComp: EditCaseComponent) { }

	ngOnInit() {
		this._nakazatelnoDelo = new Nakazatelno();
		this._nakazatelnoDelo.lawyer = new Lawyer();
		this.loadNakTemplates();
		this.instances = this.parentComp.instances;
		this.cities = this.parentComp.cities;
		this.courts = this.parentComp.courts;
		this.statuses = this.parentComp.nakazatelniStatuses;
		this.statusesTask = this.parentComp.statusesTask;
		this.lawyers = this.parentComp.lawyers;
		this.loadData();
	}

	@Input()
	public set editedCase(val: Case) {
		this.edit(val);
	}

	public get nakazatelnoDelo() {
		return this._nakazatelnoDelo;
	}

	private refresh() {
		this.message = '';
		this.addDelo = 'Добави инстанция';
		this.selectedNakStatusId = null;

		if (this._nakazatelnoDelo) {
			const currentLawyer = this._nakazatelnoDelo.lawyer;  // запазваме

			this._nakazatelnoDelo = new Nakazatelno();

			this._nakazatelnoDelo.lawyer = currentLawyer;
		}
		else {
			this._nakazatelnoDelo = new Nakazatelno();
		}

	}

	public delete(obj) {
		if (confirm('Сигурни ли сте, че искате да изтриете инстанцията?')) {
			this.blockUi.start(this.vcRef);
			this.caseService.deleteNakazatelno(obj.id).subscribe(
				result => {
					this.blockUi.stop();
					alert('Инстанцията беше изтрита успешно!');
					this.refresh();
					this.loadData();
				},
				error => {
					this.blockUi.stop();
					const msg = error.error && error.error.message
						? error.error.message
						: 'Възникна грешка с триенето на инстанцията!';
					alert(msg);
				});
		}
	}

	private changeOtgovornik() {
		if (this.nakazatelnoDelo.lawyer.id == null) {
			alert('Моля, изберете отговорник!');
			return;
		}

		this.caseService.changeOtgovornikNakazatelno(this._caseid, this.nakazatelnoDelo.lawyer).subscribe(
			lawyer => {
				//alert('Отговорникът беше сменен успешно!');
			},
			error => {
				alert('Възникна грешка със смяната на отговорник!');
			});
	}

	private edit(caseObj: Case): void {
		this.refresh();
		if (caseObj && caseObj.id) {
			this._caseid = caseObj.id;
			if (caseObj.nakazatelnoDelo && caseObj.nakazatelnoDelo.id) {
				this._nakazatelnoDelo.copy(caseObj.nakazatelnoDelo);
			}

		}
	}

	public addTask() {
		if (!this.task.deadline || !this.task.opisanie || !this.task.otgovornik || !this.selectedTask) {
			alert('Моля попълнете всички полета!');
			return;
		}
		this.blockUi.start(this.vcRef);
		this.nakazatelniTasks = new Array<TaskFrx>();
		this.task.statusTask = this.selectedTask.name;
		this.taskService.addTask(this.task, this._caseid, true).subscribe(lst => {
			this.nakazatelniTasks = lst;
			this.loadData();
			this.task = new TaskFrx();
			this.blockUi.stop();
		},
			error => {
				this.blockUi.stop();
			});
	}

	public removeTask(t) {
		if (!confirm('Сигурни ли сте, че искате да изтриете тази задача?')) {
			return;
		}
		this.blockUi.start(this.vcRef);
		this.taskService.deleteTask(t.id).subscribe(result => {
			alert('Задачата е изтрита успешно!');
			this.loadData();
			this.blockUi.stop();
		},
			error => {
				this.blockUi.stop();
			});
	}

	prepareNakazatelnoDto(nd: Nakazatelno): any {
		return {
			...nd,

			// ДАТИ → backend must receive YYYY-MM-DD
			dataNasrocheno: this.caseService.toBackendIsoDate(nd.dataNasrocheno)
		};
	}

	public addNakazatelnoDelo() {
		this.blockUi.start(this.vcRef);

		this.nakazatelnoDelo.lawsuiteId = this._caseid;
		
		const dto = this.prepareNakazatelnoDto(this.nakazatelnoDelo);

		this.caseService.saveNakazatelno(dto, ).subscribe(
			result => {
				this.refresh();
				this.loadData();
				this.blockUi.stop();
			},
			error => {
				const msg = error.error && error.error.message
					? error.error.message
					: 'Възникна грешка с добавянето на инстанция!';
				alert(msg);
				this.blockUi.stop();
			});
	}

	copyNakazatelenStatus(row) {
		this.message = 'В момента редактирате наказателен статус!';
		this.addDelo = 'Запиши дадената инстанция';
		this.selectedNakStatusId = row.id;

		const currentLawyer = this.nakazatelnoDelo.lawyer;  // запазваме

		this._nakazatelnoDelo = row;

		this._nakazatelnoDelo.lawyer = currentLawyer;

		if (row.dataNasrocheno) {
			this._nakazatelnoDelo.dataNasrocheno =
				this.datePipe.transform(new Date(row.dataNasrocheno), 'dd.MM.yyyy');
		}
	}

	compareFrxObjects(o1: FrxBaseBean, o2: FrxBaseBean) {
		if (o1 && o2) {
			return o1.id === o2.id;
		}
	}

	private loadNakTemplates() {
		this.wordTemplateService.findByType('NAKAZATELNO').subscribe(
			data => this.nakTemplates = data,
			err => { }
		);
	}

	generateDocument() {
		if (!this.selectedNakTemplate || !this._caseid || !this.selectedNakStatusId) return;
		this.blockUi.start(this.vcRef);
		this.wordTemplateService.generateDocument(this.selectedNakTemplate.id, this._caseid, this.selectedNakStatusId).subscribe(
			resp => {
				this.blockUi.stop();
				const blob = resp.body;
				const url = window.URL.createObjectURL(blob);
				const a = document.createElement('a');
				a.href = url;
				a.download = this.selectedNakTemplate.name + '_generated.docx';
				a.click();
				window.URL.revokeObjectURL(url);
			},
			err => {
				this.blockUi.stop();
				alert('Грешка при генериране на документ');
			}
		);
	}

	// 🚀 Всички "loads" в една паралелна заявка
	private loadData() {
		if (!this._caseid) {
			return;
		}

		this.blockUi.start(this.vcRef);

		this.task = new TaskFrx();
		this.nakazatelniTasks = [];
		this.cases = [];
		this.otgovornici = [];

		forkJoin([
			this.caseService.getNakazatelni(this._caseid),       // таблицата с наказателни
			this.taskService.getTasks(this._caseid, true),       // задачите за наказателни
			this.caseService.getOtgovorniciNakazatelno(),        // списък с отговорници
			this.caseService.getNakazatelnoLawyer(this._caseid)  // текущ отговорник
		]).subscribe(
			([fetchedDela, tasks, fetchedOtgovornici, lawyer]) => {

				this.cases = fetchedDela;

				this.nakazatelniTasks = tasks.map(t => {
					let statusTaskBG = '';
					switch (t.statusTask) {
						case 'NOVA': statusTaskBG = 'НОВА'; break;
						case 'V_PROCESS': statusTaskBG = 'В ПРОГРЕС'; break;
						case 'IZPULNEN': statusTaskBG = 'ИЗПЪЛНЕНА'; break;
					}
					t.statusTaskBG = statusTaskBG;
					return t;
				});

				this.otgovornici = fetchedOtgovornici;

				this.nakazatelnoDelo.lawyer = lawyer || new Lawyer();

				this.blockUi.stop();
			},
			_ => this.blockUi.stop()
		);
	}

}
